import { Component, inject, signal, computed } from '@angular/core';
import { CreateSparkCampaign } from '../../service/create-spark-campaign/create-spark-campaign';

@Component({
  selector: 'bttv2-advertising-objective-parent',
  imports: [],
  templateUrl: './advertising-objective-parent.html',
  styleUrl: './advertising-objective-parent.css',
})
export class AdvertisingObjectiveParent {

  advertisingObjectives: { type: 'awareness' | 'consideration' | 'conversion', objective: string, api_value: string }[] = [
    { type: 'awareness', objective: 'Reach', api_value: 'REACH' },
    { type: 'consideration', objective: 'Traffic', api_value:  'TRAFFIC' },
    { type: 'consideration', objective: 'Video Views', api_value: 'VIDEO_VIEWS' },
    { type: 'consideration', objective: 'Community Interaction', api_value: 'ENGAGEMENT' },
    { type: 'conversion', objective: 'App Promotion', api_value: 'APP_PROMOTION' },
    { type: 'conversion', objective: 'Lead Generation', api_value: 'LEAD_GENERATION' },
    { type: 'conversion', objective: 'Website Conversions', api_value: 'WEB_CONVERSIONS' },
    { type: 'conversion', objective: 'Product Sales', api_value: 'PRODUCT_SALES' },
    { type: 'conversion', objective: 'Sales', api_value: 'WEB_CONVERSIONS' },
  ]

  engagementObjectivesByType = computed((): {
    type: 'awareness' | 'consideration' | 'conversion';
    sectionLabel: string;
    objectives: { type: 'awareness' | 'consideration' | 'conversion'; objective: string; api_value: string }[];
  }[] => {
    const byType = new Map<
      'awareness' | 'consideration' | 'conversion',
      { type: 'awareness' | 'consideration' | 'conversion'; objective: string; api_value: string }[]
    >();
    for (const objective of this.advertisingObjectives) {
      if (!byType.has(objective.type)) {
        byType.set(objective.type, []);
      }
      byType.get(objective.type)!.push(objective);
    }
    return Array.from(byType.entries()).map(([type, objectives]) => ({
      type,
      sectionLabel: type.charAt(0).toUpperCase() + type.slice(1),
      objectives,
    }));
  });

  /** Services */
  public createSparkCampaignService = inject(CreateSparkCampaign);
  /** Services - END */

  selectAdvertisingObjective(objective: { type: 'awareness' | 'consideration' | 'conversion'; objective: string; api_value: string }) {
    this.createSparkCampaignService.selectedAdvertisingObjective.set(objective);
  }

  getSelectedAdvertisingObjectiveClass(api_value: string) {
    return this.createSparkCampaignService.selectedAdvertisingObjective()?.api_value === api_value ? 'border-2 border-primary' : 'border border-gray-200';
  }
  
}
